import { RESET_SELECTION, RESET_STANDARD } from "~/Configurators/common/advancedTranslationUtils";
import { SubstepType } from "~/Configurators/Linear/dtos";
import type { ConfiguratorDefinition } from "~/Configurators/common/v2/StepDefinition";
import { RESET_STANDARD_AND_LENGTH } from "~/Configurators/Linear/advancedTranslationsTransformer";
import * as RailCstic from "./TKLTRailsCstics";
import {
  type AlarHelperTextFactoryParams,
  ExtraConfig,
  HelperCstics,
  InputCstics,
} from "~/Configurators/Rail/components/ConfigureRailSubstep/constants";
import { getCsticNumericValue } from "~/Configurators/common/v2/helper";
import { userIsCustomer } from "~/utils/roles";

export const TKLTRailsDefinition: ConfiguratorDefinition = {
  description: [
    {
      condition: ({ mainKmat }) => {
        return mainKmat.cstics[RailCstic.GuidewayDesign]?.value === "TKLT";
      },
      value: "configurator.rail.summary.TKLT.description",
    },
  ],
  mediaUrl: [
    {
      condition: ({ mainKmat }) => {
        return mainKmat.cstics[RailCstic.GuidewayDesign]?.value === "TKLT";
      },
      value: "configurator.rail.summary.TKLT.image",
    },
  ],
  pages: [
    {
      name: "configurator.rail.page.1.name",
      enabled: true,
      resetLabel: RESET_SELECTION,
      resetRequiresConfirmation: false,
      substeps: [
        {
          type: SubstepType.Series,

          name: "configurator.rail.step.series.name",
          description: "configurator.rail.step.series.description",

          tiles: [
            {
              name: "configurator.rail.cstic.guidewayDesign.TKLT.title",
              description: "configurator.rail.cstic.guidewayDesign.TKLT.description",
              info: "configurator.rail.cstic.guidewayDesign.TKLT.info",
              imageUrl: "configurator.rail.cstic.guidewayDesign.TKLT.image",
              cstics: [
                {
                  csticName: RailCstic.GuidewayDesign,
                  value: "TKLT",
                },
              ],
            },
          ],
          tilesPerRow: 4,

          csticsToReset: [RailCstic.GuidewayDesign],

          visible: true,
        },
        {
          type: SubstepType.Size,

          name: "configurator.rail.step.size.name",
          description: "configurator.rail.step.size.description",

          tiles: [
            {
              name: "15",
              cstics: [
                {
                  csticName: RailCstic.Size,
                  value: "15",
                },
              ],
            },
            {
              name: "20",
              cstics: [
                {
                  csticName: RailCstic.Size,
                  value: "20",
                },
              ],
            },
            {
              name: "25",
              cstics: [
                {
                  csticName: RailCstic.Size,
                  value: "25",
                },
              ],
            },
            {
              name: "30",
              cstics: [
                {
                  csticName: RailCstic.Size,
                  value: "30",
                },
              ],
            },
            {
              name: "35",
              cstics: [
                {
                  csticName: RailCstic.Size,
                  value: "35",
                },
              ],
            },
            {
              name: "45",
              cstics: [
                {
                  csticName: RailCstic.Size,
                  value: "45",
                },
              ],
            },
          ],
          tilesPerRow: 12,

          csticsToReset: [RailCstic.Size],

          visible: true,
        },
      ],
    },
    {
      name: "configurator.rail.page.2.name",
      enabled: true,
      resetLabel: RESET_STANDARD,
      resetRequiresConfirmation: false,
      substeps: [
        {
          type: SubstepType.Coating,

          name: "configurator.rail.step.coating.name",
          description: "configurator.rail.step.coating.description",
          info: "configurator.rail.step.coating.info",

          tiles: [
            {
              name: "configurator.rail.cstic.coating./.name",
              cstics: [
                {
                  csticName: RailCstic.Coating,
                  value: "NONE",
                },
              ],
            },
            /*             {
              name: "configurator.rail.cstic.coating.RROC.name",
              description: "configurator.rail.cstic.coating.RROC.description",
              info: "configurator.rail.cstic.coating.RROC.info",
              cstics: [
                {
                  csticName: RailCstic.Coating,
                  value: "RROC",
                },
              ],
            }, */
          ],
          tilesPerRow: 4,

          csticsToReset: [RailCstic.Coating],

          visible: true,
        },
        {
          type: SubstepType.Accuracy,

          name: "configurator.rail.step.accuracy.name",
          description: "configurator.rail.step.accuracy.description",
          info: "configurator.rail.step.accuracy.info.TKLT",

          tiles: [
            {
              name: "G1",
              cstics: [
                {
                  csticName: RailCstic.Accuracy,
                  value: "G1",
                },
              ],
            },
            {
              name: "G2",
              cstics: [
                {
                  csticName: RailCstic.Accuracy,
                  value: "G2",
                },
              ],
            },
            {
              name: "G3",
              cstics: [
                {
                  csticName: RailCstic.Accuracy,
                  value: "G3",
                },
              ],
            },
            {
              name: "G4",
              cstics: [
                {
                  csticName: RailCstic.Accuracy,
                  value: "G4",
                },
              ],
            },
          ],
          tilesPerRow: 6,

          csticsToReset: [RailCstic.Accuracy],

          visible: true,
        },
      ],
    },
    {
      name: "configurator.rail.page.3.name",
      enabled: true,
      resetLabel: RESET_STANDARD,
      resetRequiresConfirmation: false,
      substeps: [
        {
          type: SubstepType.Mounting,
          visible: true,

          name: "configurator.rail.step.mounting.name",

          tiles: [
            {
              name: "configurator.rail.cstic.mounting./.name",
              info: "configurator.rail.cstic.mounting./.info",
              imageUrl: "configurator.rail.cstic.mounting./.imageUrl",
              cstics: [
                {
                  csticName: RailCstic.MountingHoleType,
                  value: "O",
                },
              ],
            },
            {
              name: "configurator.rail.cstic.mounting.U.name",
              info: "configurator.rail.cstic.mounting.U.info",
              imageUrl: "configurator.rail.cstic.mounting.U.imageUrl",
              cstics: [
                {
                  csticName: RailCstic.MountingHoleType,
                  value: "U",
                },
              ],
            },
          ],
          tilesPerRow: 4,

          csticsToReset: [RailCstic.MountingHoleType],
        },
        {
          type: SubstepType.Closure,
          visible: [
            {
              condition: ({ mainKmat }) => {
                return mainKmat.cstics[RailCstic.MountingHoleType]?.value !== "U";
              },
              value: true,
            },
          ],

          name: "configurator.rail.step.closure.name",
          info: "configurator.rail.step.closure.info",

          groupedTiles: [
            {
              name: "configurator.rail.step.closure.section.plugs.name",
              visible: true,
              tiles: [
                {
                  name: "configurator.rail.cstic.closure.KA-TN/B.name",
                  description: "configurator.rail.cstic.closure.KA-TN/B.description",
                  imageUrl: "configurator.rail.cstic.closure.KA-TN/B.imageUrl",
                  info: "configurator.rail.cstic.closure.KA-TN/B.info",
                  cstics: [
                    {
                      csticName: RailCstic.ClosingPlugs,
                      value: "K3",
                    },
                  ],
                },
                {
                  name: "configurator.rail.cstic.closure.KA-M/A.name",
                  description: "configurator.rail.cstic.closure.KA-M/A.description",
                  imageUrl: "configurator.rail.cstic.closure.KA-M/A.imageUrl",
                  info: "configurator.rail.cstic.closure.KA-M/A.info",
                  cstics: [
                    {
                      csticName: RailCstic.ClosingPlugs,
                      value: "M2",
                    },
                  ],
                },
                //          {
                //            name: "configurator.rail.cstic.closure.WITHOUT.name",
                //            cstics: [
                //              {
                //                csticName: RailCstic.ClosingPlugs,
                //                value: "NONE",
                //              },
                //            ],
                //          },
              ],
            },
            //      {
            //        name: "configurator.rail.step.closure.section.cover.name",
            //        visible: true,
            //        tiles: [
            //          {
            //            name: "configurator.rail.cstic.closure.ADE.name",
            //            description: "configurator.rail.cstic.closure.ADE.description",
            //            info: "configurator.rail.cstic.closure.ADE.info",
            //            imageUrl: "configurator.rail.cstic.closure.ADE.imageUrl",
            //            cstics: [
            //              {
            //                csticName: RailCstic.CoveringStrip,
            //                value: "ADE",
            //              },
            //            ],
            //          },
            //        ],
            //      },
            //      {
            //        name: "configurator.rail.step.closure.section.holes.name",
            //        visible: [
            //          {
            //            condition: ({ mainKmat }) => {
            //              if (
            //                mainKmat.cstics[RailCstic.ClosingPlugs]?.value === "NONE"
            //              ) {
            //                return true;
            //              }
            //              return false;
            //            },
            //            value: false,
            //          },
            //        ],
            //        tiles: [
            //          {
            //            name: "configurator.rail.cstic.closure.hole.counterbored.name",
            //            description: "configurator.rail.cstic.closure.hole.counterbored.description",
            //            info: "configurator.rail.cstic.closure.hole.counterbored.info",
            //            imageUrl: "configurator.rail.cstic.closure.hole.counterbored.imageUrl",

            //            cstics: [
            //              {
            //                csticName: RailCstic.CounterboreChamfered,
            //                value: "N",
            //              },
            //            ],
            //          },
            //          {
            //            name: "configurator.rail.cstic.closure.hole.chamfered.name",
            //            description: "configurator.rail.cstic.closure.hole.chamfered.description",
            //            info: "configurator.rail.cstic.closure.hole.chamfered.info",
            //            imageUrl: "configurator.rail.cstic.closure.hole.chamfered.imageUrl",

            //            cstics: [
            //              {
            //                csticName: RailCstic.CounterboreChamfered,
            //                value: "J",
            //              },
            //            ],
            //          },
            //        ],
            //      },
          ],
          tilesPerRow: 6,

          csticsToReset: [RailCstic.ClosingPlugs],
        },
      ],
    },
    {
      name: "configurator.rail.page.4.name",
      enabled: true,
      resetLabel: RESET_STANDARD_AND_LENGTH,
      resetRequiresConfirmation: false,
      substeps: [
        {
          type: SubstepType.LocatingFace,
          visible: true,

          name: "configurator.rail.step.locatingFace.name",
          description: "configurator.rail.step.locatingFace.description",
          info: "configurator.rail.step.locatingFace.info",

          tiles: [
            {
              name: "configurator.rail.cstic.locatingFace.O.name",
              imageUrl: "configurator.rail.cstic.locatingFace.O.image",
              cstics: [
                {
                  csticName: RailCstic.LocatingFace,
                  value: "O",
                },
              ],
            },
            // {
            //   name: "configurator.rail.cstic.locatingFace.U.name",
            //   imageUrl: "configurator.rail.cstic.locatingFace.U.image",
            //   cstics: [
            //     {
            //       csticName: RailCstic.LocatingFace,
            //       value: "U",
            //     },
            //   ],
            // },
          ],
          tilesPerRow: 4,

          csticsToReset: [RailCstic.LocatingFace],
        },
        {
          type: SubstepType.ConfigureRail,
          visible: true,

          name: "configurator.rail.page.4.name",

          extraTexts: {
            upperMessage: "configurator.rail.step.guidewaySet.infoMessage.upper",
            lowerMessage: "configurator.rail.step.guidewaySet.infoMessage.lower",
            lengthName: "configurator.rail.cstic.guidewayLength.name", // TODO - Move to cstic
            lengthInfo: "configurator.rail.cstic.guidewayLength.info", // TODO - Move to cstic
            alarName: "configurator.rail.section.alar.name",
            alarInfo: "configurator.rail.section.alar.info",
            alarRecommended: "configurator.rail.section.alar.recommended",
            alarWarningMessage: "configurator.rail.section.alar.warning",
            partsSectionName: "configurator.rail.section.parts.name",
            partsSectionInfo: "configurator.rail.section.parts.info",
          },

          inputCstics: {
            [InputCstics.TotalLength]: {
              name: RailCstic.GuidewayLength,
              required: true,
            },
            [InputCstics.aL]: {
              name: RailCstic.AL,
              visible: [
                {
                  condition: ({ mainKmat }) => {
                    return getCsticNumericValue(mainKmat, RailCstic.GuidewayLength) > 0;
                  },
                  value: true,
                },
                {
                  condition: () => true,
                  value: false,
                },
              ],
              required: true,
            },
            [InputCstics.aR]: {
              name: RailCstic.AR,
              disabled: true,
              visible: [
                {
                  condition: ({ mainKmat }) => {
                    return getCsticNumericValue(mainKmat, RailCstic.GuidewayLength) > 0;
                  },
                  value: true,
                },
                {
                  condition: () => true,
                  value: false,
                },
              ],
            },
            [InputCstics.partSizingType]: {
              name: RailCstic.PartSizing,
              disabled: true,
              visible: [
                {
                  condition: ({ mainKmat }) => {
                    return getCsticNumericValue(mainKmat, RailCstic.GuidewayLength) > 0;
                  },
                  value: true,
                },
                {
                  condition: () => true,
                  value: false,
                },
              ],
            },
            [InputCstics.partAmount]: {
              name: RailCstic.PartAmount,
              disabled: true,
              visible: [
                {
                  condition: ({ mainKmat }) => {
                    return getCsticNumericValue(mainKmat, RailCstic.GuidewayLength) > 0;
                  },
                  value: true,
                },
                {
                  condition: () => true,
                  value: false,
                },
              ],
            },
          },

          helperCstics: {
            [HelperCstics.totalLengthMin]: {
              name: RailCstic.GuidewayLengthMin,
            },
            [HelperCstics.totalLengthMax]: {
              name: RailCstic.GuidewayLengthMax,
            },
            [HelperCstics.alHardMax]: {
              name: RailCstic.FixedHoleDistance,
            },
            [HelperCstics.arHardMax]: {
              name: RailCstic.FixedHoleDistance,
            },
            [HelperCstics.alRecommendedMin]: {
              name: RailCstic.ALMin,
            },
            [HelperCstics.alRecommendedMax]: {
              name: RailCstic.ALMax,
            },
            [HelperCstics.arRecommendedMin]: {
              name: RailCstic.ALMin,
            },
            [HelperCstics.arRecommendedMax]: {
              name: RailCstic.ALMax,
            },
          },

          extraConfig: {
            [ExtraConfig.AlarHelperTextFactory]: ({
              hardMin = 0,
              hardMax = 0,
              recommendedMin = 0,
              recommendedMax = 0,
              t,
              value,
            }: AlarHelperTextFactoryParams) => {
              if (value === null) {
                return (
                  `${t("common.recommended")}\n` +
                  `${t("common.min")} ${recommendedMin} / ${t("common.max")} ${recommendedMax}`
                );
              }
              if (value <= hardMin) {
                return "<=0mm";
              }
              if (value >= hardMax) {
                return `>=${hardMax}mm`;
              }
              // SCHAEFF-36121 - TKLT should only show min/recommended when outside of values.
              if (value < recommendedMin || value > recommendedMax) {
                return (
                  `${t("common.recommended")}\n` +
                  `${t("common.min")} ${recommendedMin} / ${t("common.max")} ${recommendedMax}`
                );
              }

              return "";
            },
            [ExtraConfig.showNotRecommendedWarning]: true,
          },

          csticsToReset: [RailCstic.GuidewayLength, RailCstic.AL, RailCstic.AR],
        },
      ],
    },
    {
      name: "configurator.rail.page.5.name",
      enabled: true,
      resetLabel: "",
      resetRequiresConfirmation: false,
      substeps: [
        {
          type: SubstepType.SummaryPage,
          visible: true,

          info: [
            {
              condition: ({ mainKmat }) => {
                return userIsCustomer();
              },
              value: "configurator.rail.summary.info.above.business",
            },
            {
              condition: ({ mainKmat }) => {
                return true;
              },
              value: "configurator.rail.summary.info.above.plus",
            },
          ],
        },
      ],
    },
  ],
};
